export default __webpack_public_path__ + "89bd5ac63fb15b86aa69fe1ed792c467.png";